import React from 'react'

import style from './Favorites.module.scss'

const Favorites = () => {
	return <section className={style.favortes}>Favorites</section>
}

export default Favorites
